import * as tslib_1 from "tslib";
import mapItemTypeToItemRelation from '../../store-factory/mapItemTypeToItemRelation';
import { shouldShowAttachmentPreviewsForItem } from 'owa-mail-attachment-previews';
import { getValidCouponIndexesForItem } from 'owa-mail-coupon-peek';
import { listViewStore } from 'owa-mail-list-store';
import getTableToRowRelationKey from 'owa-mail-list-store/lib/utils/getTableToRowRelationKey';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { mailStore } from 'owa-mail-store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
function partialUpdateItem(itemToUpdate, item, tableView) {
    if (tableView.tableQuery.type !== 1 /* Search */) {
        // Skip updating the ItemId for search table, as the ItemId.ChangeKey in executeSearch results are different
        itemToUpdate.ItemId = item.ItemId;
        // Skip updating ReceivedOrRenewTime as it's not returned
        itemToUpdate.ReceivedOrRenewTime = item.ReceivedOrRenewTime;
        // Skip updating the validCouponIndexes because it's not returned in search
        itemToUpdate.validCouponIndexes = item.validCouponIndexes;
    }
    // Common partial update
    itemToUpdate.Subject = item.Subject;
    itemToUpdate.Importance = item.Importance;
    itemToUpdate.Sensitivity = item.Sensitivity;
    itemToUpdate.HasAttachments = item.HasAttachments;
    itemToUpdate.ItemClass = item.ItemClass;
    itemToUpdate.Flag = item.Flag;
    itemToUpdate.Categories = item.Categories;
    itemToUpdate.SystemCategories = item.SystemCategories;
    itemToUpdate.PredictedActionReasons = item.PredictedActionReasons;
    // Mail folder specific updates
    itemToUpdate.ParentFolderId = item.ParentFolderId;
    itemToUpdate.ConversationId = item.ConversationId;
    itemToUpdate.DateTimeReceived = item.DateTimeReceived;
    itemToUpdate.IsDraft = item.IsDraft;
    itemToUpdate.Size = item.Size;
    itemToUpdate.IsClutter = item.IsClutter;
    itemToUpdate.Preview = item.Preview;
    itemToUpdate.DisplayTo = item.DisplayTo;
    itemToUpdate.IconIndex = item.IconIndex;
    itemToUpdate.PolicyTag = item.PolicyTag;
    itemToUpdate.ArchiveTag = item.ArchiveTag;
    // Only update return time if item provides value
    if (!!item.ReturnTime) {
        itemToUpdate.ReturnTime = item.ReturnTime;
    }
    // Message specific updates
    if (itemToUpdate.ItemClass.indexOf('IPM.Schedule.Meeting') !== -1 ||
        itemToUpdate.ItemClass.indexOf('IPM.Note') !== -1) {
        var messageToUpdate = itemToUpdate;
        var message = item;
        messageToUpdate.IsRead = message.IsRead;
        if (tableView.tableQuery.type !== 1 /* Search */) {
            // Skip updating the following properties in search as they're not returned
            messageToUpdate.IsReadReceiptRequested = message.IsReadReceiptRequested;
            messageToUpdate.IsDeliveryReceiptRequested = message.IsDeliveryReceiptRequested;
        }
    }
}
/**
 * Adds or updates the item in the mail store
 * This is called whenever a data is fetched from the server and is being stored. This is also called when
 * a rowAdd or rowModified notificaiton occurs
 * @param item to add or update
 * @param tableView where to add or update the item
 * @param state for unit testing
 */
export default select({
    items: function () { return mailStore.items; },
    tableViewItemRelations: function () { return listViewStore.tableViewItemRelations; },
})(action('addOrUpdateItemData')(function addOrUpdateItemData(serviceItem, tableView, state) {
    var itemId = serviceItem.ItemId.Id;
    var clientItemToMerge = tslib_1.__assign({}, serviceItem, { MailboxInfo: getMailboxInfo(tableView), validCouponIndexes: getValidCouponIndexesForItem(serviceItem, tableView.tableQuery), shouldShowAttachmentPreviews: getUserConfiguration().UserOptions.ShowInlinePreviews &&
            shouldShowAttachmentPreviewsForItem(serviceItem, tableView.tableQuery) });
    if (state.items.has(itemId)) {
        // If the item is in the cache, partial update it with the new properties
        var itemInCache = state.items.get(itemId);
        partialUpdateItem(itemInCache, clientItemToMerge, tableView);
    }
    else {
        // Otherwise add it to the item cache
        state.items.set(itemId, clientItemToMerge);
    }
    var tableItemRelationKey = getTableToRowRelationKey(serviceItem.InstanceKey, tableView.id);
    // Create or update the relation object
    var newRelation = mapItemTypeToItemRelation(serviceItem, tableView);
    state.tableViewItemRelations.set(tableItemRelationKey, newRelation);
}));
//# sourceMappingURL=addOrUpdateItemData.js.map